import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { PageApiService } from './page-api-client.service';
import { CtBatch } from '../model/ct-batch-model';
import { PageImageService } from '@ps-gui/shared-document-preview';

@Injectable({ providedIn: 'root' })
export class CtBatchThumbnailPreloadService {
  private readonly pageImageService = inject(PageImageService);
  private readonly pageApiClient = inject(PageApiService);

  preloadThumbnails(batches: CtBatch[]): Observable<unknown> {
    this.pageImageService.initImageData(
      batches
        .flatMap((batch) => batch.documents)
        .flatMap((document) => document.pages.map((page) => page.id)),
    );

    return forkJoin(batches.map((batch) => this.loadThumbnails(batch.id)));
  }

  private loadThumbnails(batchId: string): Observable<unknown> {
    return this.pageApiClient.loadThumbnails(batchId).pipe(
      map((result) => {
        const entries = Object.entries(result);
        entries.forEach(([pageId, thumbnailBase64]) => {
          this.pageImageService
            .getImageData(pageId)
            .thumbnailSrc.set(`data:image/jpeg;base64,${thumbnailBase64}`);
        });
      }),
    );
  }
}
